import { RefObject } from "react";
import { IForwardPagination } from "react-common-components/dist/components/Pagination/interface";
import IBaseDTO from "src/Interfaces/baseDTO";

export interface IField {
    iqb001Id: number;
    iqb001Descricao: string;
    iqb001Label: string;
    iqb001Codigo:string;
}

export interface IOrigin{
    iqb002Id:number;
    iqb002Tipo:IndicatorFieldType;
    iqb002Formula:string;
    iqb002Dtvalini:Date;
    iqb002Dtvalfim:Date;
    iqb002Efa020Id?:number;
    iqb002Descricao:string;
    iqb002Wstiporet:WebServiceReturn;
    iqb002Wspathret:string;
    showFormula?:boolean;
}

export interface IIndicatorFieldForm extends IBaseDTO {
    iqb001Id: number;
    iqb001Descricao: string;
    iqb001Label: string;
    iqb001Codigo:string;
    iqb001Casasdecimais:number;
    iqtbb002: IOrigin[];
}

export interface IRefIndicatorFieldModals {
    actionButtonAdd: (callback?: Function) => void;
    actionButtonChange: (row:IField, callback?: Function, indicator?: number,copy?:boolean) => void;
    actionButtonDelete: (row:IField) => void;
}

export interface IComponentIndicatorFieldModals {
    paginationRef?: RefObject<IForwardPagination>;
    onClose?:(field:IIndicatorFieldForm)=>void;
}

export enum IndicatorFieldType {
    INFORMED = "1",
    FORMULA = "2",
    INTEGRATION = "3",
    WEBSERVICE = "4"
}

export enum WebServiceReturn {
    XML = "1",
    JSON = "2"
}
